import {
  type Middleware,
  combineReducers,
  configureStore
} from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import { wsMiddleware } from '@/integrations/socket.connector';

import appSlice from './app.slice';
import authSlice from './auth.slice';
import autoCreditOffersSlice from './auto-credit-offers.slice';

const rootReducer = combineReducers({
  app: appSlice.reducer,
  auth: authSlice.reducer,
  autoCreditOffers: autoCreditOffersSlice.reducer
});

const middleware: Middleware[] = [wsMiddleware];

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware)
});

export const dispatch = store.dispatch.bind(store);
export type TRootState = ReturnType<typeof store.getState>;
type TAppDispatch = typeof store.dispatch;

export const useAppDispatch: () => TAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
